import React from "react";
import './index.css'
import { secureUrl } from "../../../../utils/sortArray/secureUrl";

const TeamsSelector = ({teams, selectTeam})=>{
    return(<div  className="selector-container-from-teams">

        <div className="teams-selector-container">
            <div  onClick={()=> selectTeam('local')} className={`team-selector-container ${teams?.selectedTeam === 'local' ? 'active' : '' }`}>
                <img
                src={ secureUrl(teams?.
matchInfo
?.equipoLocal?.pictureTeam)} />
<p>{teams?.matchInfo?.equipoLocal?.name}</p>
            </div>
            <div onClick={()=> selectTeam('visitor')} className={`team-selector-container ${teams?.selectedTeam === 'visitor' ? 'active' : '' }`}>
              <img src={secureUrl(teams?.
matchInfo
?.equipoVisitante?.pictureTeam)} />
<p>{teams?.matchInfo?.equipoVisitante?.name}</p>

            </div>
        </div>

    </div>)
}

export default TeamsSelector